// @flow
import React, { Component } from 'react';
import { Button, Divider, Form, Label, Loader, Modal, Radio, Tab } from 'semantic-ui-react';
import { getDeliveryMethods, getNotificationUsers, shareAttachment } from '../../modules/client';
import NewMessagePane from '../molecules/NewMessagePane';
import PermissionsPane from '../molecules/PermissionsPane';
import { cloneDeep } from 'lodash';

type State = {
    attached: ?AttachmentType,
    deliveryTypes: DeliveryType[],
    selectedDeliveryMethods: Array<number>,
    message: string,
    newPermissions: Array<{ id: Guid, selected: boolean }>,
    phone: string,
    saving: boolean,
    selectedTab: number,
    subject: string,
    userId: ?string,
    users: Array<User>
};

export default class ShareModal extends Component<
    {
        additionalOptions: ?Object,
        attachmentId: ?Guid,
        attachmentType: string,
        clientId: string,
        exportTypes: Array<AttachmentType>,
        onClose: () => void,
        onShare: (Guid, any) => Promise<void>,
        onSavePermissions: (Guid, Guid, Array<{ id: Guid, selected: boolean }>) => Promise<void>,
        open: boolean,
        users: UserWithAnalyticsObject[]
    },
    State
> {
    static defaultProps = { additionalOptions: {} };
    constructor() {
        super();
        this.state = {
            attached: { text: undefined, icon: undefined, value: undefined },
            deliveryTypes: [],
            selectedDeliveryMethods: [],
            message: '',
            newPermissions: [],
            phone: '',
            saving: false,
            selectedTab: 0,
            subject: '',
            userId: undefined,
            users: []
        };
    }
    getDefaultselectedDeliveryMethods(deliveryTypes: DeliveryType[]) {
        let selectedDeliveryMethods = [];
        if (deliveryTypes.length === 1) {
            selectedDeliveryMethods.push(deliveryTypes[0].Id);
        }
        return selectedDeliveryMethods;
    }
    componentDidMount() {
        // Promise.all([getDeliveryMethods(), getNotificationUsers()])
        //     .then(([deliveryTypes, users]) => {
        //         let selectedDeliveryMethods = this.getDefaultselectedDeliveryMethods(deliveryTypes);
        //         this.setState({ deliveryTypes, users, selectedDeliveryMethods });
        //     })
        //     .catch(err => console.error(err));
    }
    // prettifyPhone(prev: string, next: string) {
    //     if (prev.length > next.length && prev.endsWith('-')) {
    //         return prev.slice(0, -1);
    //     }
    //     return next;
    // }
    onChangeRecipient = (key: string, value: string) => {
        let newValue = value;
        // if (key === 'phone') {
        //     const prev = this.state[key];
        //     newValue = this.prettifyPhone(prev, value);
        // }
        this.setState({ [key]: newValue });
    };
    getEndpointValue = (methodId: number) => {
        const { deliveryTypes, phone, userId, users } = this.state;
        const deliveryType = deliveryTypes.find(type => type.Id === methodId);
        const user = users.find(el => el.userId === userId);
        const curType = deliveryType ? deliveryType.Name : 'Email';
        switch (curType) {
            case 'Sms':
                return `+1${phone}`;
            case 'AppMessage':
                return user ? user.userId : null;
            case 'PushNotification':
                return user ? user.pushTokens : null;
            case 'Email':
                return user ? user.email : null;
            default:
                return user ? user.userId : null;
        }
    };
    onSubmit(e: SyntheticEvent<HTMLFormElement>) {
        const { attached } = this.state;
        if (!this.state.saving) {
            this.setState({ saving: true });
            const { message, selectedDeliveryMethods, subject, deliveryTypes } = this.state;
            const { additionalOptions, attachmentId, attachmentType, clientId } = this.props;

            const endpoints = selectedDeliveryMethods.reduce((prev, curMethod) => {
                const endpoint = this.getEndpointValue(curMethod);
                if (Array.isArray(endpoint)) {
                    endpoint.forEach(el => prev.push({ deliveryMethodId: curMethod, value: el }));
                } else {
                    prev.push({ deliveryMethodId: curMethod, value: endpoint });
                }
                return prev;
            }, []);

            const data = Object.assign({}, additionalOptions, {
                endpoints,
                exportType: attached ? attached.value : null,
                message,
                subject,
                clientUid: clientId
            });
            // close popup
            this.props.onClose();
            if (attachmentId) {
                return this.props
                    .onShare(attachmentId, data)
                    .then(rs =>
                        this.setState({
                            selectedDeliveryMethods: this.getDefaultselectedDeliveryMethods(
                                deliveryTypes
                            ),
                            subject: '',
                            message: '',
                            saving: false
                        })
                    )
                    .catch(err => {
                        console.error(err);
                        this.setState({ saving: false });
                    });
            } else {
                this.setState({ saving: false });
            }
        }
        e.preventDefault();
    }
    handleTabChange = (
        e: SyntheticEvent<HTMLFormElement>,
        data: {
            activeIndex: number,
            grid: { paneWidth: number, tabWidth: number },
            menu: { secondary: boolean, pointing: boolean },
            panes: [{ menuItem: string }],
            renderActiveOnly: boolean
        }
    ) => {
        const tabName = data.panes[data.activeIndex].menuItem;
        if (tabName === 'Permissions') {
            this.setState({ selectedTab: data.activeIndex });
        }
    };
    renderPermissionsPane = () => {
        return (
            <PermissionsPane
                users={this.props.users}
                onChange={param => {
                    let permission = this.state.newPermissions.find(
                        perm => perm.id === param.data.id
                    );
                    if (permission) {
                        permission.selected = param.node.selected;
                    } else {
                        this.state.newPermissions.push({
                            id: param.data.id,
                            selected: param.node.selected
                        });
                    }
                    const newPermissions = cloneDeep(this.state.newPermissions);
                    this.setState({ newPermissions });
                }}
            />
        );
    };
    renderNewMessagePane = () => {
        return <NewMessagePane />;
    };
    render() {
        const props = this.props;
        const { attached, selectedDeliveryMethods, phone, userId, selectedTab } = this.state;

        const deliveryTypes = this.state.deliveryTypes.map(el => ({
            text: el.FriendlyName,
            value: el.Id
        }));

        // if (!this.state.deliveryTypes || !this.state.users.length) {
        //     return props.open ? (
        //         <div>
        //             <Loader active size="large">{`Loading...`}</Loader>
        //         </div>
        //     ) : null;
        // }
        const users = this.state.users.map(user => ({ text: user.fullName, value: user.userId }));
        const panes = [
            { menuItem: 'Permissions', render: this.renderPermissionsPane }
            // { menuItem: 'New Message', render: this.renderNewMessagePane }
        ];
        return (
            <Modal
                closeIcon
                dimmer="inverted"
                onClose={(e, data) => {
                    this.setState({ newPermissions: [] });
                    props.onClose();
                }}
                open={props.open}
                size="small"
            >
                <Modal.Header>Share</Modal.Header>
                <Modal.Content>
                    <Tab
                        menu={{ secondary: true, pointing: true }}
                        panes={panes}
                        onTabChange={this.handleTabChange}
                        activeIndex={selectedTab}
                    />
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        content="Save"
                        form="newmessage"
                        icon="save"
                        loading={this.state.saving}
                        primary
                        type="submit"
                        onClick={() => {
                            if (this.props.attachmentId) {
                                this.props.onSavePermissions(
                                    this.props.clientId,
                                    this.props.attachmentId,
                                    cloneDeep(this.state.newPermissions)
                                );
                                this.setState({ newPermissions: [] });
                            }
                        }}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./components/molecules/ShareModal.jsx